import gql from 'graphql-tag';

export const RESEND_WELCOME_EMAIL = gql`
  mutation resendWelcomeEmail($accountId: ID!) {
    resendWelcomeEmail(accountId: $accountId) {
      success
    }
  }
`;

// Letter of Experience generator (#29700). Returns a ToolResult; on success the letter is
// uploaded to the policy's Internal Documents (details carries the file name / S3 key).
export const GENERATE_LOE = gql`
  mutation generateLoe($args: GenerateLoeInput!, $taskRunId: String!) {
    generateLoe: toolsGenerateLoe(args: $args, taskRunId: $taskRunId) {
      ... on ToolSuccess {
        success
        details
      }
      ... on ToolError {
        success
        error
      }
    }
  }
`;

export const SEND_ACCOUNT_LOGIN_LINK = gql`
  mutation sendAccountLoginLink($accountId: ID!, $channel: AccountLoginLinkChannel!) {
    sendAccountLoginLink(accountId: $accountId, channel: $channel) {
      success
    }
  }
`;
